/*
* lms2.0 跳转
*/
import mAppImg from '@p/assets/images/app.png'
import config from '@/config'
import CallApp from 'callapp-lib'

class skip {
  constructor() {
    this.path = [
      {
        old: 'synopsis',
        new: 'home/lessons/study'
      },
      {
        old: 'admin',
        new: 'admin/login'
      },
    ]
  }
  renader() {
    if (location.pathname !== '/') {
      const pathname = location.pathname.split('/')
      const pathInfoIndex = this.path.findIndex(item => {
        return pathname.indexOf(item.old) != -1
      })
      if (pathInfoIndex != -1) {
        const pathInfo = this.path[pathInfoIndex]
        const synopsis = pathname.indexOf(pathInfo.old)
        if (pathInfo.old === 'admin') { // 跳转到后管理页面
          location.href = `${config.admin}/${pathInfo.new}`
        } else if (pathInfo.old === 'synopsis' && synopsis != -1) { // 课程页面
          location.href = `${location.origin}/#/${pathInfo.new}?id=${pathname[synopsis + 1]}`
        } else {
          location.href = `${location.origin}/#/${pathInfo.new}`
        }
      } else {
        location.href = `${location.origin}/#/home/`
      }
    }
  }
  callappArouse() {
    const options = {
      scheme: {
        protocol: 'sjappschemelinking'
      },
      intent: {
        package: 'com.sjfood.mobile.sjapp',
        scheme: 'sjappschemelinking'
      },
      fallback: location.href,
    }
    const callLib = new CallApp(options)
    callLib.open({
      param: {},
      path: ''
    })
  }
  createCallappElement () {
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    const isAndroid = !!(u.match(/(Android)\s+([\d.]+)/));
    if (isiOS || isAndroid) {
      const $section = document.createElement('section')
      const $div = document.createElement('div')
      $section.style = 'position: fixed;top: 0;left: 0;z-index: 100;width: 100%;height: 100%;background: rgba(0,0,0,.5);display: flex;justify-content: center;align-items: center;'
      $section.innerHTML = '<div style="width: 70%;height: 110px;background: #fff;border-radius: 5px;padding: 10px 0 0 10px;position: relative;">請轉移到SJAPP中進入LMS系統，謝謝<div id="makeDownloadApp" style="min-width: 20px;height: 20px;position: absolute;right: 80px;bottom: 20px;color: #4d8ef6;">下載</div><div id="makeOpenApp" style="min-width: 20px;height: 20px;position: absolute;right: 20px;bottom: 20px;color: #4d8ef6;">打開</div></div>'
      document.querySelector('body').appendChild($section)
      document.querySelector('#makeDownloadApp').addEventListener('click', (e)=> { // 跳转下载
        let src = config.callappAndroidSrc
        if (isAndroid) {
          src = config.callappAndroidSrc
        } else if (isiOS) {
          src = config.callappIosSrc
        }
        window.location.href = src
      })
      document.querySelector('#makeOpenApp').addEventListener('click', (e)=> { // 打开
        this.callappArouse()
      })
    }
  }
  createCallappImgElement () {
    const $section = document.createElement('section')
    $section.style = 'position: fixed;top: 0;left: 0;z-index: 1000;width: 100vw;height: 100vh;'
    $section.innerHTML = `<img style='width: 100%;' src='${mAppImg}' />`
    document.querySelector('body').appendChild($section)
  }
  callappElement() {
    const ua = navigator.userAgent.toLowerCase();
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
    const isAndroid = !!(u.match(/(Android)\s+([\d.]+)/));
    const isWx = ua.match(/MicroMessenger/i) == "micromessenger"
    const isDt = ua.match(/DingTalk/i) == "dingtalk"
    if (isiOS || isAndroid) {
      if (isWx || isDt) {
        this.createCallappImgElement()
      } else {
        this.createCallappElement()
      }
    }
  }
}
export default skip